module.exports = "/images/checkboxUnchecked.svg?b27c991a1bf0a3510ea295cbc0c15c02";